"use client";
import { jsx as c } from "react/jsx-runtime";
import { l as r } from "../../../lodash-B7QmW1Cn.js";
import P, { useState as m, useMemo as d, useCallback as l, use as f } from "react";
const u = P.createContext(null), C = ({ children: e }) => {
  const [a, n] = m([]), s = d(() => a[0], [a]), i = l((t) => {
    r.isString(t) && n((o) => [...o, t]), r.isArray(t) && n((o) => r.concat(o, t));
  }, []), p = l(() => {
    n((t) => r.reject(t, (o) => o === s));
  }, [s]);
  return /* @__PURE__ */ c(
    u.Provider,
    {
      value: {
        currentPortal: s,
        openPortal: i,
        closePortal: p
      },
      children: /* @__PURE__ */ c(
        "div",
        {
          "data-vaul-drawer-wrapper": !0,
          className: "bg-body !origin-[center_top]",
          children: e
        }
      )
    }
  );
}, g = () => {
  const e = f(u);
  if (!e)
    throw new Error(
      "usePortalContext: `context` is undefined. Seems you forgot to wrap all popover components within `<PortalModal />`"
    );
  return e;
};
export {
  C as PortalProvider,
  g as usePortalContext
};
